import React from 'react'

import NotFound from 'pages/NotFound'
import OptedOut from 'pages/Device/OptedOut'
import NotEnrolled from 'pages/Device/NotEnrolled'
import AssignedSystemTime from 'pages/Device/AssignedSystemTime'

import { Device } from 'types/Device'

import { NoData, LoadingSinglePanePage } from 'styles/shared'

const fallbackContent = (isDeviceLoaded :boolean, device: Device | null, refreshPageCallback:(() => void | null)| undefined, brandName :string) => {
  if (!isDeviceLoaded) {
    return <LoadingSinglePanePage /> // Loading
  } else if (!device) {
    return <NotFound /> // device not found
  } else if (device.deviceModel?.includes('950')) { // not supported device
    return (
      <>
        <NoData>
          <h1>NOT SUPPORTED</h1>
          <h2>This device cannot be displayed because it's not supported.</h2>
        </NoData>
        <AssignedSystemTime device={device} refreshPageCallback={refreshPageCallback} />
      </>
    )
  } else if (!device.optedIn) {
    if (device.status === 'DEALER MISMATCH') {
      return (
        <>
          <NoData>
            <h1>THIS DEVICE BELONGS TO ANOTHER DEALER</h1>
            <h2>
              The dealer code entered on the device is different from your dealer code. Please contact {brandName} Support for assistance at 844-359-0270
            </h2>
          </NoData>
          <AssignedSystemTime device={device} refreshPageCallback={refreshPageCallback} />
        </>
      )
    } else if (device.status === 'OPTED OUT') {
      return (
        <>
          <OptedOut deviceType={device.deviceType} deviceModel={device.deviceModel} />
          <AssignedSystemTime device={device} refreshPageCallback={refreshPageCallback} />
        </>
      )
    } else { // not enrolled
      return (
        <>
          <NotEnrolled />
          <AssignedSystemTime device={device} refreshPageCallback={refreshPageCallback} />
        </>
      )
    }
  }

  return null
}

export default fallbackContent
